<template>
  <vs-dropdown
    style="cursor: pointer"
    vs-custom-content
    vs-trigger-click
  >
    <vs-button
      color="primary"
      type="border"
      icon-pack="feather"
      icon="icon-more-vertical"
    ></vs-button>

    <vs-dropdown-menu>
      <vs-dropdown-item
        :disabled="
          params.data.invoice_payment_status_id === 1 ||
          params.data.is_shared_to_client !== 0
        "
        @click="params.colDef.CellRendererParams.addManualInvice(params.data, true)"
      >
        Edit
      </vs-dropdown-item>
      <vs-dropdown-item
        @click="params.colDef.CellRendererParams.deleteManualInvoiceConfirm(params.data)"
      >
        Delete
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  name: 'ActionsCell'
}
</script>